import React, { useState, useEffect } from 'react'
import { getLogsList } from './ActionCreator';
import { getExotelcallHisotryListByFilters } from '../ExotelCall/ActionCreator';
import Loader from '../../../presentationals/Loader/Loader.component'
import Pagination from '@mui/material/Pagination';
import NodataImage from '../../../../images/nodata.png'
import moment from 'moment';
import { getDownloadReportForCommunicationLogsByData } from '../AdminActionCreator.component';
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';

const size = 10;
export default function Logs() {
    const dispatch = useDispatch();
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
    const [filters, setFilters] = useState({
        startDate: fromDate,
        endDate: toDate,
        status: "SENT",
        type: "EMAIL",
    })
    const [loader, setLoader] = useState(false)
    const [currentPage, setcurrentPage] = useState(0)
    const [listData, setListData] = useState([])
    const [totalPages, setTotalPages] = useState(0)

    useEffect(() => {
        // getLogsListFn(currentPage)
        const obj = {
            startDate: fromDate,
            endDate: toDate,
            status: "SENT",
            type: "EMAIL",
        }
        setFilters(obj)
        getExotelcallHisotryListByFiltersFn(obj, currentPage)
    }, [fromDate, toDate])

    const getLogsListFn = (page) => {
        setLoader(true)
        getLogsList((page - 1), size, callback => {
            setLoader(false)
            setListData(callback?.content)
            setTotalPages(callback?.totalPages)
        })
    }
    const getExotelcallHisotryListByFiltersFn = (payload, page) => {
        setLoader(true)
        const start = payload?.startDate + " 00:00:00";
        const end = payload?.endDate + " 23:59:59";
        console.log(payload?.type, payload?.status, start, end, page, size)
        getExotelcallHisotryListByFilters(payload?.type, payload?.status, start, end, page, size, callback => {
            setLoader(false)
            setListData(callback?.data?.content)
            setTotalPages(callback?.data?.totalPages)
        })
    }

    const handlePagePagination = (event, value) => {
        setcurrentPage(value - 1);
        // getLogsListFn(value)
        getExotelcallHisotryListByFiltersFn(filters, value - 1)
    };

    const handlechange = (event, type) => {
        if(type == "startDate") {
             dispatch({ type: FILTER_ACTION, payload: { fromDate: e.target.value } });
        }
        if(type == "endDate") {
             dispatch({ type: FILTER_ACTION, payload: { toDate: e.target.value } });
        }
        setFilters((prev) => ({
            ...prev,
            [type]: event?.target.value
        }))
    }

    const handleApply = () => {
        setcurrentPage(0);
        getExotelcallHisotryListByFiltersFn(filters, 0)
    }


    const downloadReport = () => {
        const start = filters?.startDate + " 00:00:00";
        const end = filters?.endDate + " 23:59:59";
        setLoader(true)
        const data = {
            type: filters?.type,
            status: filters?.status,
            startDate: start,
            endDate: end,
            campaignName: '',
            leadName: ''
        }
        getDownloadReportForCommunicationLogsByData(data, callback => {
            setLoader(false)
        })
    }

    return (
        <>
            <div className="container-fluid" style={{ margin: '120px 0 40px 0' }}>
                {
                    loader ? <Loader /> : ''
                }

                <div className="row">
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="">Start Date</label>
                        <input className="form-control" value={filters?.startDate} type="date" onChange={(e) => handlechange(e, "startDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="">End Date</label>
                        <input className="form-control" value={filters?.endDate} type="date" onChange={(e) => handlechange(e, "endDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="">Communication Type</label>
                        <select className='form-control' value={filters?.type} onChange={(e) => handlechange(e, "type")}>
                            <option value={"EMAIL"}>Email</option>
                            <option value={"SMS"}>SMS</option>
                            <option value={"WHATSAPP"}>Whatsapp</option>
                            <option value={"CALL"}>Call</option>
                            <option value={"NOTIFICATION"}>Notification</option>
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <label htmlFor="">Communication Status</label>
                        <select className='form-control' value={filters?.status} onChange={(e) => handlechange(e, "status")}>
                            <option value={"SENT"}>Sent</option>
                            <option value={"FAILED"}>Failed</option>
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-6" style={{ display: 'flex', gap: '10px' }}>
                        <button className='btn btn-primary ' style={{ padding: '10px', marginTop: '22px' }} onClick={() => handleApply()}>Apply</button>
                        <button className='btn btn-primary ' style={{ padding: '10px', marginTop: '22px' }} onClick={() => downloadReport()}><i className='fa fa-download'></i></button>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-sm-12 col-xs-12">

                        {listData !== '' && listData?.length > 0 ?
                            <>
                                <div className="phocket-table-new" style={{ boxShadow: '3px 3px 10px 3px #eee', borderRadius: '15px', marginTop: '0' }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Communication Id</th>
                                                <th className='text-center'>Step Id</th>
                                                <th className='text-center'>Communication Type</th>
                                                <th className='text-center'>status</th>
                                                {/* <th className='text-center'>content</th> */}
                                                <th className='text-center'>communicate To</th>
                                                {/* <th className='text-center'>vendor Id</th> */}
                                                <th className='text-center'>Added On</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listData && listData?.length > 0 ? listData?.map((data, i) => (
                                                <tr key={i}>
                                                    <td className='text-center'>{data?.communicationId}</td>
                                                    <td className='text-center'>{data?.stepId}</td>
                                                    <td className='text-center'>{data?.type}</td>
                                                    <td className='text-center'>{data?.status}</td>
                                                    {/* <td className='text-center'>{data?.content}</td> */}
                                                    <td className='text-center'>{data?.communicateTo}</td>
                                                    {/* <td className='text-center'>{data?.vendorId}</td> */}

                                                    <td className='text-center'>{data?.creationDate}</td>
                                                </tr>
                                            )) : ""}
                                        </tbody>
                                    </table>
                                    <div style={{ float: "right", marginTop: '20px' }}>
                                        <Pagination
                                            count={totalPages}
                                            page={currentPage + 1}
                                            onChange={handlePagePagination}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                            </>
                            :
                            <div style={{ width: '100%' }} className="text-center"><img style={{ width: '30%', marginTop: '50px', marginLeft: 'auto', marginRight: 'auto' }} src={NodataImage} /></div>}


                    </div>
                </div>

            </div>
        </>
    )
}
